<template>
    <div class="youtube-section">
      <b-row>
        <b-col :span="24">
          <b-form-checkbox
            :checked="isYoutubeEnabled"
            @change="handleYoutubeChange"
            name="isYoutube"
          >
            <span class="label">{{ $t('Youtube') }}</span>
          </b-form-checkbox>
        </b-col>
      </b-row>
  
      <!-- Existing rows -->
      <div style="margin-top:12px">
        <div v-for="(lang, index) in listLang" :key="index" style="display:flex; gap:10px; align-items:center; position:relative;">
          <input type="checkbox" class="custom-input" checked @click="removeLanguage(index)" />
          <b-form-select v-model="lang.lang" :options="filteredSelectOptions" style="width:80px;" />
          <div style="position:relative; flex:1;">
            <b-form-input 
              v-model="lang.link" 
              style="padding-right: 40px;" 
              placeholder="https://youtube..." 
            />
            <span
              class="copy-icon copy-icon-inside"
              @click="copyLink(lang, index, $event)"
              :class="{ copied: copiedIndex === index }"
              title="Copy link"
            >
              <font-awesome-icon icon="copy" />
            </span>
          </div>
        </div>
      </div>
  
      <!-- New row -->
      <div
        v-if="openMenu && listLang.length < 7"
        style="display:flex; gap:10px; align-items:center; margin-top:6px"
      >
        <input
          type="checkbox"
          class="custom-input"
          v-model="isEnabled"
          style="flex-shrink:0"
        />
  
        <b-form-select
          v-model="languageUrl"
          :options="filteredSelectOptions"
          :disabled="!isEnabled"
          style="width:80px; flex-shrink:0"
        />
  
        <div style="position:relative; flex:1;">
          <b-form-input
            v-model="inputYoutube"
            :disabled="!isEnabled"
            @input="validateNewRow"
            style="padding-right: 40px;"
            placeholder="https://youtube..."
          />
          <span
            class="copy-icon copy-icon-inside"
            :class="{ disabled: !inputYoutube }"
            @click="copyNewRowLink($event)"
            title="Copy link"
          >
            <font-awesome-icon icon="copy" />
          </span>
        </div>
      </div>
  
      <!-- Error messages -->
      <b-row style="margin-top:8px">
        <b-col v-if="errorMessage" :span="24">
          <span class="errorUrl">{{ errorMessage }}</span>
        </b-col>
        <b-col v-if="duplicateError" :span="24">
          <span class="errorUrl">{{ duplicateError }}</span>
        </b-col>
      </b-row>
      <!-- Add button -->
      <b-row style="text-align:center; margin-top:10px">
        <b-col :span="24">
          <b-button
            v-if="openMenu && listLang.length < 7"
            :disabled="!canAddNew"
            @click="handleAjouter"
          >
            {{ $t('form_live.tabs.advanced.diffusion.addyoutubeLanguage') }}
          </b-button>
        </b-col>
      </b-row>
  
    </div>
  </template>
  
  <script>
  export default {
    name: "YouTubeLinks",
  
    props: {
      initialYoutubeEnabled: Boolean,
      initialYoutubeLinks: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        isYoutubeEnabled: !!this.initialYoutubeEnabled,
        openMenu: !!this.initialYoutubeEnabled,
        listLang: this.initialYoutubeLinks.map(l => ({ ...l })),
        inputYoutube: "",
        languageUrl: null,
        isEnabled: false,
        duplicateError: "",
        errorMessage: "",
        options: [
          { value: "fr", text: "Fr" },
          { value: "en", text: "En" },
          { value: "ar", text: "Ar" },
          { value: "fl", text: "FL" },
          { value: "sp", text: "SP" },
          { value: "ch", text: "Ch" },
          { value: "ru", text: "Ru" },
          { value: "zh", text: "Zh" }
        ],
        copiedIndex: null
      };
    },
  
    computed: {
      filteredSelectOptions() {
        return this.options.map(opt => ({
          ...opt,
          disabled: this.listLang.some(l => l.lang === opt.value)
        }));
      },
  
      canAddNew() {
        const url = this.inputYoutube.trim();
        return this.isEnabled && this.languageUrl && url && this.isValidUrl(url) && !this.listLang.some(l => l.link === url);
      }
    },
  
    methods: {
      isValidUrl(url) {
        const urlRegex = /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
        return urlRegex.test(url);
      },
  
      validateNewRow(e) {
        const value = e;
        const link = value.trim();
  
        if (!link) {
          this.errorMessage = this.$t('form_live.tabs.advanced.diffusion.emptyInput');
          return;
        }
  
        if (this.listLang.some(l => l.link === link)) {
          this.duplicateError = this.$t('form_live.tabs.advanced.diffusion.duplicateUrl');
          this.errorMessage = "";
          return;
        }
  
        if (!this.isValidUrl(link)) {
          this.errorMessage = this.$t('form_live.tabs.advanced.diffusion.validUrl');
          this.duplicateError = "";
          return;
        }
  
        this.errorMessage = "";
        this.duplicateError = "";
      },
  
      handleYoutubeChange(val) {
        this.isYoutubeEnabled = val;
        this.openMenu = val;
  
        if (!val) {
          this.listLang = [];
          this.$emit('update:youtubeLinks', []);
        }
  
        this.$emit('update:youtubeEnabled', val);
      },
  
      removeLanguage(index) {
        this.listLang.splice(index, 1);
        this.$emit('update:youtubeLinks', this.listLang);
      },
  
      validateEditRow(i) {
        const link = this.listLang[i].link.trim();
  
        if (!link) {
          this.errorMessage = this.$t('Translate.emptyInput');
          return;
        }
  
        if (this.listLang.some((l, idx) => idx !== i && l.link === link)) {
          this.duplicateError = this.$t('Translate.Input');
          this.errorMessage = "";
          return;
        }
  
        if (!this.isValidUrl(link)) {
          this.errorMessage = this.$t('Translate.validUrl');
          return;
        }
  
        this.errorMessage = "";
        this.duplicateError = "";
        this.$emit('update:youtubeLinks', this.listLang);
      },
  
      copyLink(lang, index, e) {
        e.preventDefault();
  
        if (!lang || !lang.link) return;
  
        navigator.clipboard.writeText(lang.link);
        this.copiedIndex = index;
        setTimeout(() => {
          this.copiedIndex = null;
        }, 400);
      },
  
      copyNewRowLink(e) {
        e.preventDefault();
        
        if (!this.inputYoutube) return;
        navigator.clipboard.writeText(this.inputYoutube);
        this.copiedIndex = 'new';
        setTimeout(() => {
          this.copiedIndex = null;
        }, 400);
      },
  
      handleAjouter() {
        const link = this.inputYoutube.trim();
        this.listLang.push({ lang: this.languageUrl, link });
        this.inputYoutube = "";
        this.languageUrl = null;
        this.isEnabled = false;
        this.$emit('update:youtubeLinks', this.listLang);
      }
    }
  };
  </script>
  
  <style scoped>
  .youtube-section {
    width: 100%;
  }
  .label {
    font-weight: 500;
  }
  .custom-input {
    cursor: pointer;
  }
  .errorUrl {
    color: #ff4d4f;
    font-size: 12px;
    margin-top: 4px;
  }
  .copy-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 6px;
    border-radius: 8px;
    cursor: pointer;
    transition: transform 0.2s, opacity 0.2s;
  }
  .copy-icon-inside {
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    padding: 4px 6px;
    z-index: 10;
  }
  .copy-icon:hover:not(.disabled) {
    opacity: 0.7;
    transform: translateY(-50%) scale(1.15);
  }
  
  .copy-icon:active:not(.disabled) {
    transform: translateY(-50%) scale(0.9);
  }
  
  .copy-icon.copied {
    transform: translateY(-50%) scale(1.3);
    opacity: 1;
    animation: flash 0.4s;
  }
  
  .copy-icon.disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
  
  @keyframes flash {
    0% { opacity: 1; transform: translateY(-50%) scale(1.3); }
    50% { opacity: 0.3; transform: translateY(-50%) scale(1.3); }
    100% { opacity: 1; transform: translateY(-50%) scale(1.3); }
  }
  </style>


// WEBPACK FOOTER //
// src/components/YoutubeLinks.vue